import {ResearchLitElement, html, css} from '@core/research-lit-element';

export class ResearchFilterScroll extends ResearchLitElement {
    static get is() {
        return 'research-filter-scroll';
    }

    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    overflow-x: hidden;
                    height: var(--scroll-height, inherit);
                    scrollbar-color: var(--scroll-background-color, transparent)
                        var(--scroll-background-color, transparent);
                    scrollbar-width: thin;
                }

                :host::-webkit-scrollbar {
                    width: var(--scroll-width, 5px);
                    background-color: var(--scroll-background-color, transparent);
                }

                :host::-webkit-scrollbar-thumb {
                    background-color: var(--scroll-bar-color, var(--color-invert-component-tr-60));
                    opacity: var(--scroll-bar-opacity, 0.8);
                }
            `,
        ];
    }

    render() {
        return html` <slot></slot> `;
    }
}
window.customElements.define(ResearchFilterScroll.is, ResearchFilterScroll);
